import { render, staticRenderFns } from "./invigilateDetail.vue?vue&type=template&id=abfcc254&scoped=true"
import script from "./invigilateDetail.vue?vue&type=script&lang=js"
export * from "./invigilateDetail.vue?vue&type=script&lang=js"
import style0 from "./invigilateDetail.vue?vue&type=style&index=0&id=abfcc254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abfcc254",
  null
  
)

export default component.exports